module.exports = __webpack_public_path__ + "media/newstyle/images/icon-apple-43e585766eed1ecf1b96e9b602a978e6.svg";